import { createService } from './serviceFactory';

const baseService = createService('/api/supplier/tenant-review');

export default {
  async searchTenantReviews(params = {}) {
    const uiPage = Number.isFinite(params.page) ? params.page : 1;
    const payload = {
      searchText: params.searchText || '',
      page: Math.max(uiPage - 1, 0),
      pageSize: Number.isFinite(params.pageSize) ? params.pageSize : 6,
      ...(Number.isFinite(params.minRating) ? { minRating: params.minRating } : {}),
      ...(Number.isFinite(params.maxRating) ? { maxRating: params.maxRating } : {}),
      ...(params.materialCategoryId ? { materialCategoryId: params.materialCategoryId } : {}),
      ...(params.countryId ? { countryId: params.countryId } : {}),
      ...(params.portId ? { portId: params.portId } : {}),
      ...(params.isLookupAssociated !== undefined && params.isLookupAssociated !== null ? { isLookupAssociated: params.isLookupAssociated } : {}),
      ...(params.sort ? { sort: params.sort } : {})
    };

    const response = await baseService.client.post('/api/supplier/tenant-review/search', payload);
    return response.data;
  },

  /**
   * Profile page: full review summary for a supplier tenant (not search).
   */
  async getSupplierReviewSummary(supplierTenantId) {
    if (!supplierTenantId) {
      return null;
    }
    const response = await baseService.client.get(
      `/api/supplier/tenant-review/supplier-summary/${encodeURIComponent(supplierTenantId)}`
    );
    return response.data;
  },

  /**
   * POST /api/supplier/tenant-review/reviews-for-supplier — paged reviews with filters.
   * Request: tenantId?, supplierTenantId, buyerTenantId?, minRating?, maxRating?, reviewDateStart?, reviewDateEnd?, comment?, page (0-based), pageSize.
   * Response: items, currentPage, pageSize, rowCount, totalCount.
   */
  async searchTenantReviewComments(payload) {
    const response = await baseService.client.post(
      '/api/supplier/tenant-review/reviews-for-supplier',
      payload
    );
    return response.data;
  },

  async createReviewForTenant({ tenantId, rating, comment }) {
    return this.createOrUpdateTenantReview({
      supplierTenantId: tenantId,
      rating,
      comment: comment || ''
    });
  },

  async createReviewReply({ reviewId, message, parentReplyId }) {
    const id = reviewId;
    const payload = {
      message: message || ''
    };
    if (parentReplyId) {
      payload.parentReplyId = parentReplyId;
    }
    const response = await baseService.client.post(
      `/api/supplier/tenant-review/add-reply`,
      payload,
      {
        params: { reviewId: id }
      }
    );
    return response.data;
  },

  async deleteTenantReview(id) {
    const response = await baseService.client.delete(`/api/supplier/tenant-review/${id}`);
    return response.data;
  },

  async getTenantReviewById(id) {
    const response = await baseService.client.get(`/api/supplier/tenant-review/${id}`);
    return response.data;
  },

  async getTenantReviewReplies(reviewId) {
    const response = await baseService.client.get(`/api/supplier/tenant-review/replies/${reviewId}`);
    return response.data;
  },

  async createOrUpdateTenantReview(payload) {
    const response = await baseService.client.post('/api/supplier/tenant-review/or-update', payload);
    return response.data;
  }
};
